import { init } from './views/widget';
import { IConfigurations, IGlobalObject, ICustomWindow } from './views/interface';
const supportedAPI = ['init'];

const app = (window: ICustomWindow) => {
	console.log('VIEW-EHW starting');

	let configurations: IConfigurations = {
		someDefaultConfiguration: false
	};
	const globalObject = window[window['VIEW-EHW']];
	// const globalObject = (window as any)[globalObjectKey] as IGlobalObject;
	const queue = globalObject.q;

	if (queue) {
		for (let i = 0; i < queue.length; i++) {
			if (queue[i][0].toLowerCase() == 'init') {
				configurations = extendObject(configurations, queue[i][1]) as IConfigurations;

				//throw error if elementId is not a valid value
				if (!configurations.elementId || configurations.elementId === '') {
					throw Error('VIEW Exclusive Homes Widget: Element Id is required for REV Widget to work');
				}

				if (!document.getElementById(configurations.elementId)) {
					throw Error(
						'VIEW Exclusive Homes Widget: Element with id=' +
							configurations.elementId +
							' not found in DOM. Stopping'
					);
				}
				init(queue[i][1]);
			} else {
				apiHandler(queue[i][0], queue[i][1], configurations);
			}
		}
	}
	//This line enables access to API methods defined below
	//from the global "mw" variables on window object
	window[window['VIEW-EHW']] = apiHandler;
};

const apiHandler = (api: string, params: any, configurations: IConfigurations) => {
	if (!api) throw Error('API method required');
	api = api.toLowerCase();
	const { elementId } = params;
	if (supportedAPI.indexOf(api) === -1) throw Error(`Method ${api} is not supported`);

	if (api === 'init') {
		if (!elementId || elementId === '') {
			throw Error('VIEW Exclusive Homes Widget: Element Id is required for REV Widget to work');
		}

		if (!document.getElementById(elementId)) {
			throw Error('VIEW Exclusive Homes Widget: Element with id=' + elementId + ' not found in DOM. Stopping');
		}
		init(params);
	} else {
		throw new Error(`API method ${api} is not supported`);
	}
};

const extendObject = <T, U>(a: T, b: U): T & U => {
	for (const key in b) {
		if (Object.prototype.hasOwnProperty.call(b, key)) {
			(a as T & U)[key] = b[key] as any;
		}
	}
	return a as T & U;
};

app(window as unknown as ICustomWindow);
